import { toNew } from './toNew';

// 正規表現の特殊文字をエスケープする
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// 本文を「一致 / 非一致」の区間に分ける。
// 旧字体と新字体を同じ字として照合するため、toNew を掛けた本文と検索語で位置を求め、
// 切り出しは元の本文から行う (toNew は 1 字 → 1 字・BMP 内なので位置は変わらない)。
export const buildHighlightSegments = (rawText, rawKeyword) => {
  const text = String(rawText ?? '').normalize('NFC');
  const keyword = String(rawKeyword ?? '').trim().normalize('NFC');

  if (!keyword) {
    return [{ text, matched: false }];
  }

  // 保存時に日本語隣接の空白・改行を除去しているため、画面の文章と検索語で
  // 空白の有無が食い違いうる。キーワードから空白を除いたうえで 1 文字ずつ
  // エスケープし、間に \s* を挟んだ正規表現にすることで空白の有無を無視して
  // 一致させる（サロゲートペアが壊れないよう Array.from で分解する）。
  const keywordChars = Array.from(toNew(keyword)).filter((ch) => !/\s/.test(ch));
  if (keywordChars.length === 0) {
    return [{ text, matched: false }];
  }

  // 大文字小文字を区別せず照合する（DB 側の utf8mb4_unicode_ci に合わせる）
  const pattern = new RegExp(keywordChars.map(escapeRegExp).join('\\s*'), 'gi');
  const converted = toNew(text);

  const segments = [];
  let cursor = 0;
  for (const m of converted.matchAll(pattern)) {
    if (m[0].length === 0) {
      continue;
    }
    if (m.index > cursor) {
      segments.push({ text: text.slice(cursor, m.index), matched: false });
    }
    segments.push({ text: text.slice(m.index, m.index + m[0].length), matched: true });
    cursor = m.index + m[0].length;
  }
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), matched: false });
  }
  return segments;
};
